// extracted by mini-css-extract-plugin
export default {"messageBox":"QuizPage_messageBox__+NTYL","animateSquiggles":"QuizPage_animateSquiggles__bvoNG"};